"use client";

import { useFeatureFlagVariantKey, usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

const isDevAutoPublishEnabled = () =>
  process.env.NODE_ENV === "development" &&
  process.env.NEXT_PUBLIC_DEV_AUTO_PUBLISH === "true";

/** The Auto publish switch, entry button and setup card (PostHog flag `auto-publish`). */
export const useAutoPublishFlag = () => {
  const variant = useFeatureFlagVariantKey("auto-publish");
  return isDevAutoPublishEnabled() || variant === "test";
};

/** Keep the calendar entry visible until rollout eligibility is known. */
export function useAutoPublishFlagState() {
  const variant = useFeatureFlagVariantKey("auto-publish");
  const posthog = usePostHog();
  const [hasLoadedFlags, setHasLoadedFlags] = useState(() => posthog.featureFlags.hasLoadedFlags);

  useEffect(() => {
    const update = () => setHasLoadedFlags(posthog.featureFlags.hasLoadedFlags);
    update();
    return posthog.onFeatureFlags(update);
  }, [posthog]);

  if (isDevAutoPublishEnabled()) return true;

  // A missing key after loading is excluded, rather than loading forever.
  return variant === undefined && !hasLoadedFlags ? undefined : variant === "test";
}
